import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ExportCustomGridInfo,
  ExportGridInfo,
  ExportRequest,
  FileLink,
  ExportTemplate,
  TemplateCodeResponse,
  PropertyInformation,
  PropertyData,
} from '@store/search-board/search-board.model';
import { Template, TemplateCode } from '@store/user/user.model';
import { map } from 'rxjs/operators';
import { ExportLabelsRequest } from '@store/labels/labels.model';
import { PostcardsPayload } from '@shared/models/postcards-modal.model';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private readonly httpClient: HttpClient) { }

  public getGridExport(): Observable<ExportGridInfo> {
    return this.httpClient.get<ExportGridInfo>('/api/start-export-label-limits');
  }

  public getCustomExport(): Observable<ExportCustomGridInfo> {
    return this.httpClient.get<ExportCustomGridInfo>('/api/start-custom-grid-export');
  }

  public generateExportLink(exportRequest: ExportRequest): Observable<FileLink> {
    return this.httpClient.post<FileLink>('/api/export', exportRequest);
  }

  public generateExportLabelsLink(exportLabelRequest: ExportLabelsRequest): Observable<FileLink> {
    return this.httpClient.post<FileLink>('/api/print-mail-labels', exportLabelRequest);
  }

  public saveExportTemplate(exportTemplate: Template): Observable<ExportTemplate> {
    return this.httpClient.post<TemplateCodeResponse>('/api/save-export-template', exportTemplate).pipe(
      map((res: TemplateCodeResponse) => {
        return {
          name: exportTemplate.label,
          canBeDeleted: true,
          template: {
            ...exportTemplate,
            templateCode: res.templateCode as TemplateCode
          }
        };
      })
    );
  }

  public updateExportTemplate(exportTemplate: Template): Observable<ExportTemplate> {
    return this.httpClient.post<void>('/api/update-export-template', exportTemplate).pipe(
      map(() => {
        return {
          name: exportTemplate.label,
          canBeDeleted: true,
          template: exportTemplate
        };
      })
    );
  }

  public deleteExportTemplates(templateId: string): Observable<void> {
    const params = new HttpParams({
      fromObject: {
        templateId
      }
    });
    return this.httpClient.delete<void>('/api/delete-export-template', {
      params
    });
  }

  public openLink(link: string): void {
    window.open(link);
  }

  public postCard(payload: PostcardsPayload): Observable<{ downloadScvPath: string, realMailersUrl: string }> {
    return this.httpClient.post<{ downloadScvPath: string, realMailersUrl: string }>('/api/real-mailers-export', payload);
  }

  public postCardPropertyDetails(payload: Partial<PostcardsPayload>): Observable<Array<PropertyData>> {
    return this.httpClient.post<Array<PropertyInformation>>('/api/real-mailers-export-init', payload)
      .pipe(
        map(
          (propertyInformations: Array<PropertyInformation>) => propertyInformations.map((
            propertyInformation: PropertyInformation, idx: number,
          ) => ({
            ...propertyInformation.propertyData,
            INDEX: idx + 1,
          })))
      )
  }
}
